import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const api_url = "https://development.cppatidar.com/hearing/api/";
const userroleid = localStorage.getItem("access_token");

export const isLoginAPI = createAsyncThunk("isLogin", async (body) => {
  const res = await fetch(api_url + "auth/login", {
    method: "POST",
    headers: {
      "content-type": "application/json",
    },
    body: JSON.stringify(body),
  });
  return res.json();
});
export const isSignUPAPI = createAsyncThunk("isSignUPAPI", async (body) => {
  const res = await fetch(api_url + "auth/register", {
    method: "POST",
    headers: {
      "content-type": "application/json",
    },
    body: JSON.stringify(body),
  });
  return res.json();
});

export const getCountries = createAsyncThunk("getCountries", async (body) => {
  const res = await fetch(api_url + "auth/getCountries", {
    method: "get",
    headers: {
      "content-type": "application/json",
    },
    body: JSON.stringify(body),
  });
  return res.json();
});

export const getbranch = createAsyncThunk("getbranch", async (body) => {
  const res = await fetch(api_url + "getBranches", {
    method: "get",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("access_token")}`, // Include the authorization token
    },
    body: JSON.stringify(body),
  });
  return res.json();
});

export const Forgetpassword = createAsyncThunk(
  "Forgetpassword",
  async (body) => {
    const res = await fetch(api_url + "auth/forgotPassword", {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify(body),
    });
    return res.json();
  }
);

export const resetpassword = createAsyncThunk("resetpassword", async (body) => {
  const res = await fetch(api_url + "auth/resetPassword", {
    method: "POST",
    headers: {
      "content-type": "application/json",
    },
    body: JSON.stringify(body),
  });
  return res.json();
});

export const socialLogin = createAsyncThunk("socialLogin", async (body) => {
  const res = await fetch(api_url + "auth/socialLogin", {
    method: "POST",
    headers: {
      "content-type": "application/json",
    },
    body: JSON.stringify(body),
  });
  return res.json();
});

//API for TEST QUESTIONS

export const testQuestion = createAsyncThunk(
  "testQuestion",
  async (page_no) => {
    const res = await fetch(`${api_url}getTestData`, {
      method: "POST",
      headers: {
        "content-type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      },
      body: JSON.stringify(page_no),
    });
    return res.json();
  }
);

//API for CONATCT FORM  and Page

export const contactAdd = createAsyncThunk("contactAdd", async (data) => {
  const res = await fetch(`${api_url}contactUs`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
    },
    body: JSON.stringify(data),
  });
  return res.json();
});

export const userView = createAsyncThunk("userView", async (viewid) => {
  const res = await fetch(`${api_url}auth/getUserDetails`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("access_token")}`,
    },
    body: JSON.stringify(viewid),
  });
  return res.json();
});

export const Appointmentbook = createAsyncThunk(
  "Appointmentbook",
  async (body) => {
    const res = await fetch(api_url + "appointment/store", {
      method: "POST",
      headers: {
        "content-type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      },
      body: JSON.stringify(body),
    });
    return res.json();
  }
);
export const submitTest = createAsyncThunk("submitTest", async (data) => {
  const res = await fetch(`${api_url}userAnswer `, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("access_token")}`,
    },
    body: JSON.stringify(data),
  });
  return res.json();
});

export const ViewBookAppointment = createAsyncThunk(
  "ViewBookAppointment",
  async (body) => {
    const res = await fetch(api_url + "getAppointments", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("access_token")}`, // Include the authorization token
      },
      body: JSON.stringify(body),
    });
    return res.json();
  }
);

export const InvoiceData = createAsyncThunk("InvoiceData", async (body) => {
  const res = await fetch(api_url + "getInvoiceData", {
    method: "get",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("access_token")}`,
    },
    body: JSON.stringify(body),
  });
  return res.json();
});

export const RemoveAppointment = createAsyncThunk(
  "RemoveAppointment",
  async (body) => {
    const res = await fetch(api_url + "deleteAppointment", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("access_token")}`, // Include the authorization token
      },
      body: JSON.stringify(body),
    });
    return res.json();
  }
);

export const hearingpdf = createAsyncThunk("hearingpdf", async (body) => {
  const res = await fetch(api_url + "sendUserMail", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("access_token")}`, // Include the authorization token
    },
    body: JSON.stringify(body),
  });
  return res.json();
});

export const hearingpdfview = createAsyncThunk(
  "hearingpdfview",
  async (body) => {
    const res = await fetch(api_url + "getTestDataById", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("access_token")}`, // Include the authorization token
      },
      body: JSON.stringify(body),
    });
    return res.json();
  }
);
//API FOR VIEW USER_DETAILS FOR PROFILE PAGE

export const viewUserDetails = createAsyncThunk(
  "viewUserDetails",
  async (body) => {
    const res = await fetch(api_url + "user-data", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("access_token")}`, // Include the authorization token
      },
      body: JSON.stringify(body),
    });
    return res.json();
  }
);

//API FOR UPDATE USER_DETAILS FOR PROFILE PAGE

export const updateUserDetails = createAsyncThunk(
  "updateUserDetails",
  async (body) => {
    const res = await fetch(api_url + "update-user-data", body);
    return res.json();
  }
);

//API FOR REFERRAL OPTION WHEN BOOK APPOINTMENT

export const appointmentReferralOption = createAsyncThunk(
  "appointmentReferralOption",
  async (body) => {
    const res = await fetch(api_url + "getReferralTypeAppointment", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("access_token")}`, // Include the authorization token
      },
    });
    return res.json();
  }
);



export const appointmenthearOption = createAsyncThunk(
  "appointmenthearOption",
  async (body) => {
    const res = await fetch(api_url + "getVisitPurpose", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("access_token")}`, // Include the authorization token
      },
    });
    return res.json();
  }
);

//API FOR test  Hearing test History

export const testHistory = createAsyncThunk(
  "testHistoryHearing",
  async (body) => {
    const res = await fetch(api_url + "user-test", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("access_token")}`, // Include the authorization token
      },
    });
    return res.json();
  }
);

export const appointmenttimeslots = createAsyncThunk(
  "appointmenttimeslots",
  async (body) => {
    const res = await fetch(api_url + "appointment-timeslots", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("access_token")}`, // Include the authorization token
      },
      body: JSON.stringify(body),
    });
    return res.json();
  }
);

export const pointsHistory = createAsyncThunk(
  "pointsHistory",
  async (body) => {
    const res = await fetch(api_url + "get-user-points", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("access_token")}`, // Include the authorization token
      },
      body: JSON.stringify(body),
    });
    return res.json();
  }
);


export const getReferLink = createAsyncThunk(
  "getReferLink",
  async (body) => {
    const res = await fetch(api_url + "get-refer-link", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("access_token")}`, // Include the authorization token
      },
      body: JSON.stringify(body),
    });
    return res.json();
  }
);


export const subscribeEmail = createAsyncThunk(
  "subscribeEmail",
  async (body) => {
    const res = await fetch(api_url + "subscribed-email", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("access_token")}`, // Include the authorization token
      },
      body: JSON.stringify(body),
    });
    return res.json();
  }
);


